// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__o-ayC","footer":"ModalUpdate_footer__1gu6G"};